import { ReactNode, useId } from "react";

interface SectionCardProps {
    icon: ReactNode;
    title: string;
    aside?: ReactNode;
    className?: string;
    children: ReactNode;
}

/// White rounded card with an uppercase heading, used for each area page section
export function SectionCard({ icon, title, aside, className, children }: SectionCardProps) {
    const headingId = useId();
    return (
        <section className={"cw-card" + (className ? " " + className : "")} aria-labelledby={headingId}>
            <div className="cw-card__header">
                <h2 className="cw-card__title" id={headingId}>{icon}{title}</h2>
                {aside && <div className="cw-card__aside">{aside}</div>}
            </div>
            {children}
        </section>
    );
}
